'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRouter = require('react-router');

var _back = require('../../../res/images/common/back.svg');

var _back2 = _interopRequireDefault(_back);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(BackButton, _Component);

  function BackButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BackButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BackButton.__proto__ || (0, _getPrototypeOf2.default)(BackButton)).call.apply(_ref, [this].concat(args))), _this), _this.navigateBack = function () {
      _reactRouter.browserHistory.goBack();
    }, _this.backElement = function (icon) {
      return _react2.default.createElement(
        'div',
        { className: _this.props.className, onClick: _this.navigateBack },
        _react2.default.createElement('img', { src: icon || _back2.default })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BackButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: 'fadeInOutBack',
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 1
        },
        this.backElement(this.props.icon)
      );
    }
  }]);
  return BackButton;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  icon: _react.PropTypes.string
}, _temp2);
exports.default = BackButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BackButton/BackButton.js
// module id = 1942
// module chunks = 0